import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { Header, PenIcon, UserIcon } from "@/shared/ui";

interface EditProfileHeaderProps {
  resetForm: VoidFunction;
  isSaveDisabled: boolean;
}

export const EditProfileHeader = ({
  resetForm,
  isSaveDisabled,
}: EditProfileHeaderProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    resetForm();
    navigate(ROUTES.PROFILE.OVERVIEW);
  };

  return (
    <Header.Root variant="secondary">
      <Header.Content>
        <Header.Breadcrumb
          links={[
            {
              href: ROUTES.PROFILE.OVERVIEW,
              icon: UserIcon,
              label: t`My profile`,
            },
            {
              href: ROUTES.PROFILE.EDIT,
              icon: PenIcon,
              label: t`Edit profile`,
            },
          ]}
        />

        <div className="flex justify-between">
          <div className="flex items-center gap-2">
            <Header.GoBackButton onClick={handleBack} className="md:hidden" />
            <Header.Title>{t`Edit profile`}</Header.Title>
          </div>

          <Header.Actions>
            <Header.Button
              onClick={handleBack}
              variant="secondary"
              className="hidden md:block"
            >
              {t`Cancel`}
            </Header.Button>

            <Header.Button
              type="submit"
              form="edit-patient-form"
              disabled={isSaveDisabled}
            >
              {t`Save changes`}
            </Header.Button>
          </Header.Actions>
        </div>

        <Header.Description>{t`Required fields *`}</Header.Description>
      </Header.Content>
    </Header.Root>
  );
};
